<template>


  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Sensores</h4>
            <div class="small text-muted">Adminsitración de todos los sensores</div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
                  <WidgetMasonry
                    v-if="visibilityLoaded"
                    v-model="widgetsOrdered"
                    :disabled="!visibilityLoaded || editingLocked"
                    @order-end="saveWidgetOrder"
                    @resize-end="commitWidgetSize"
                  >
                    <template v-slot:default="{ item }">
                        <Widget
                          :configWidget="configWidget"
                          :reference="item.reference"
                          :hasAccess="item.hasAccess"
                          :allowHide="!editingLocked"
                          :allowDrag="!editingLocked"
                          :allowResize="!editingLocked"
                          @hide-widget="hideWidget"
                        />
                    </template>
                  </WidgetMasonry>
        </b-col>
        <b-col lg="3">        
          <b-list-group class="mb-1" v-if="configSubView.elements.sensors">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openListSensors()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Listado de Sensores</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Visualizar el estado de cada tanque y bebedero
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>
      </b-row>

    </b-col>
  </b-row>

</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry
    },    
    data: () => {
      return {
        customerID: 0,
        access: {
          module_id: Modules.SENSORES,
          profile_id: Profiles.CLIENTE,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.SENSORES,
          profile_id: Profiles.CLIENTE,
          elements: {}
        },
        configSubView: {
          module_id: Modules.SENSORES,
          profile_id: Profiles.CLIENTE,
          elements: {            
            sensors: true,
          }
        },           
        primaryColor: '',        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      
      /* Configurar permisos de las sub vistas */                 
      this.configSubView.elements.sensors = Helper.showAccessView(this.configSubView, 'listSensorsTank')                                    
      /* Fin configuracion */                                 

      /* Config Customer */      
      this.customerID = Helper.getCustomerId()
      /* Fin Config Customer */      
    },
    mounted() {
      this.setup()
    },
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },     
      openListSensors() {
        this.$router.push({ name: 'SensorsCustomerListSensorsTank' })
      }
    }
  }
</script>

<style>

</style>
